import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) { }

  /**
   * Show success toast
   * @param message Toast message
   * @param title Optional title
   */
  success(message: string, title?: string): void {
    this.toastr.success(message, title || '', {
      timeOut: 5000,
      positionClass: 'toast-top-right',
      toastClass: 'toast-custom',
      tapToDismiss: true,
      closeButton: true,
      disableTimeOut: false
    });
  }

  /**
   * Show error toast
   * @param message Toast message
   * @param title Optional title
   */
  error(message: string, title?: string): void {
    this.toastr.error(message, title || '', {
      timeOut: 5000,
      positionClass: 'toast-top-right',
      toastClass: 'toast-custom',
      tapToDismiss: true,
      closeButton: true,
      disableTimeOut: false
    });
  }

  /**
   * Show warning toast
   * @param message Toast message
   * @param title Optional title
   */
  warning(message: string, title?: string): void {
    this.toastr.warning(message, title || '', {
      timeOut: 5000,
      positionClass: 'toast-top-right',
      toastClass: 'toast-custom',
      tapToDismiss: true,
      closeButton: true,
      disableTimeOut: false
    });
  }

  /**
   * Show info toast
   * @param message Toast message
   * @param title Optional title
   */
  info(message: string, title?: string): void {
    this.toastr.info(message, title || '', {
      timeOut: 5000,
      positionClass: 'toast-top-right',
      toastClass: 'toast-custom',
      tapToDismiss: true,
      closeButton: true,
      disableTimeOut: false
    });
  }

  /**
   * Clear all toasts
   */
  clear(): void {
    this.toastr.clear();
  }
}

